<template>
  <LotteryBasePage>
    <slot>
      <NumberLotteryBasePlaySlip />
    </slot>
  </LotteryBasePage>
</template>
